/* eslint-disable react/no-array-index-key */
import React, { FC } from 'react';

import { Box, Button } from '@mui/material';
import PATHS from 'lib/navigation/paths';
import StyledBox from 'views/rebranded-module/deals-module/DealDetailsViewV2/components/DealCardsSection/DealCardsSection.styles';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import {
  DealCardV2,
  Typography700,
  Carousel,
} from 'views/rebranded-module/common/components';
import NavigatorLink from 'views/rebranded-module/common/components/Logical/NavigatorLink';


const DealCardsSection: FC<any> = (props) => {
  const { dealData, dealValue } = props;
  const content = useContent('DealDetailsPage');
  
  return (
    <StyledBox>
      <Box className="DCSHeader">
        <Typography700 component="p" variant="h4">
          {content.motorcycleRentalDealsTitle}
        </Typography700>
        <Button
          variant="contained"
          color="primary"
          className="DCSBtn"
          component={NavigatorLink}
          href={PATHS.motorcycleDeals.index()}>
          {content.viewRentalDealsBtnLabel}
        </Button>
      </Box>

      <Box position="relative" height='100%'>
        <Carousel
          swipeable
          infinite
          showDots={false}
          keyBoardControl
          minimumTouchDrag={20}
          tabletPartialVisibilityGutter={0}
          deskTopItems={3}
          largedesktopItems={4}
          carouselArrow
          customTransition="transform 200ms ease-in">
          {dealData?.related_deals.map((deal, index) => (
            <Box className="CarouselItem" key={index}>
              <DealCardV2
                title={deal.title}
                image={{
                  src: deal.image.medium_url,
                  alt: deal.title,
                }}
                tagline={deal.tagline}
                link={PATHS.motorcycleDeals.slug(
                  encodeURIComponent(deal.identifier),
                )}
                {...dealValue(
                  deal.value_wc,
                  deal.discounted_price,
                  deal.deal_type.sym_id,
                  { paid_days: deal.paid_days, free_days: deal.free_days },
                )}
                showBtn
              />
            </Box>
          ))}
        </Carousel>
      </Box>
    </StyledBox>
  );
};

export { DealCardsSection };